<template>
    <v-snackbar v-model="show">
        {{ message }}
        <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click.native="show = false">Close</v-btn>
        </template>
    </v-snackbar>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            message: ''
        }
    },
    created() {
        this.$store.watch(
            (state) => state.notification.text,
            () => {
                const message = this.$store.state.notification.text
                if (message !== '') {
                    this.show = true
                    this.message = this.$store.state.notification.text
                    this.$store.dispatch(`notification/set`)
                }
            }
        )
    }
}
</script>
